// src/belediye/redux/slices/profileSlice.js

import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../services/belediyeApi';

// PROFİL GETİR (me endpoint)
export const fetchMyProfile = createAsyncThunk(
  'profile/fetchMyProfile',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get('/common/users/me/');
      
      return response.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.detail || 'Profil bilgileri alınamadı.'
      );
    }
  }
);

// PROFİL GÜNCELLE (adı, soyadı, email, username vs.)
export const updateMyProfile = createAsyncThunk(
  'profile/updateMyProfile',
  async (updateFields, { rejectWithValue }) => {
    try {
      const config =
        updateFields instanceof FormData
          ? { headers: { 'Content-Type': 'multipart/form-data' } }
          : { headers: { 'Content-Type': 'application/json' } };

      const response = await api.patch('/common/users/me/', updateFields, config);
      return response.data;
    } catch (err) {
      let errorMsg = err.response?.data?.detail || 'Profil güncellenemedi.';
      if (err.response?.data) {
        const errors = err.response.data;
        if (typeof errors === 'object') {
          errorMsg = Object.values(errors).join(' ');
        }
      }
      return rejectWithValue(errorMsg);
    }
  }
);

// PROFİL FOTOĞRAFI YÜKLE
export const uploadProfilePhoto = createAsyncThunk(
  'profile/uploadProfilePhoto',
  async (file, { rejectWithValue }) => {
    try {
      const formData = new FormData();
      formData.append('photo', file);
      const response = await api.patch('/common/users/me/', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      return response.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.photo?.[0] ||
        err.response?.data?.detail ||
        'Profil fotoğrafı güncellenemedi.'
      );
    }
  }
);

// PROFİL FOTOĞRAFI SİL
export const deleteProfilePhoto = createAsyncThunk(
  'profile/deleteProfilePhoto',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.patch('/common/users/me/', { photo: null });
      return response.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.detail || 'Profil fotoğrafı silinemedi.'
      );
    }
  }
);

// ---
// ! user_id her çağrıda otomatik eklenecek şekilde ekstra kontrol
// ---

// DOĞRULAMA KODU GÖNDER
export const sendVerificationCode = createAsyncThunk(
  'profile/sendVerificationCode',
  async (params, { getState, rejectWithValue }) => {
    // Eğer user_id gelmiyorsa state'teki user'dan al
    const state = getState();
    const user = state.profile.user;
    const user_id = params?.user_id || user?.id;
    const { phone_number, purpose = 'password_reset' } = params;

    

    try {
      const response = await api.post('/notifications/notifications/send-verification-code/', {
        user_id,
        phone_number,
        purpose,
      });
     
      return response.data;
    } catch (err) {
      
      return rejectWithValue(
        err.response?.data?.detail || 'Doğrulama kodu gönderilemedi.'
      );
    }
  }
);

// DOĞRULAMA KODUNU DOĞRULA
export const verifyCode = createAsyncThunk(
  'profile/verifyCode',
  async (params, { getState, rejectWithValue }) => {
    const state = getState();
    const user = state.profile.user;
    const user_id = params?.user_id || user?.id;
    const { phone_number, code, purpose = 'password_reset' } = params;

    

    try {
      const response = await api.post('/notifications/notifications/verify-code/', {
        user_id,
        phone_number,
        code,
        purpose,
      });
      return response.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.detail || 'Kod doğrulanamadı.'
      );
    }
  }
);

// ŞİFRE DEĞİŞTİR
export const changePassword = createAsyncThunk(
  'profile/changePassword',
  async (params, { getState, rejectWithValue }) => {
    const state = getState();
    const user = state.profile.user;
    const user_id = params?.user_id || user?.id;
    const { phone_number, code, new_password, current_password } = params;

    try {
      const response = await api.post('/common/users/change_password/', {
        user_id,
        phone_number,
        code,
        new_password,
        current_password, //   backend eski şifre doğrulaması için şart
      });
      
      return response.data;
    } catch (err) {
     
      return rejectWithValue(
        err.response?.data?.detail ||
          err.response?.data?.error ||
          'Şifre değiştirilemedi.'
      );
    }
  }
);

// Kullanıcının kendi oturum/cihaz geçmişi (read-only)
export const fetchMySessions = createAsyncThunk(
  'profile/fetchMySessions',
  async (_arg, { rejectWithValue }) => {
    try {
      const response = await api.get('/common/users/my-sessions/');
      return response.data?.results || [];
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.detail ||
          err.response?.data?.error ||
          'Oturum geçmişi alınamadı.'
      );
    }
  }
);

// Şu anki cihaz hariç diğer aktif oturumları kapat
export const closeOtherSessions = createAsyncThunk(
  'profile/closeOtherSessions',
  async (_arg, { dispatch, rejectWithValue }) => {
    try {
      const response = await api.post('/common/users/close-other-sessions/');
      // Kapatma sonrası listeyi tazele
      dispatch(fetchMySessions());
      return response.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.detail ||
          err.response?.data?.error ||
          'Diğer oturumlar kapatılamadı.'
      );
    }
  }
);

const initialState = {
  user: null,
  loading: false,
  error: null,
  // --- PROFİL GÜNCELLEME ---
  updateLoading: false,
  updateError: null,
  updateSuccess: null,
  // --- KULLANICI ADI ---
  usernameEditLoading: false,
  usernameEditError: null,
  usernameEditSuccess: null,
  // --- EMAIL ---
  emailEditLoading: false,
  emailEditError: null,
  emailEditSuccess: null,
  // --- FOTOĞRAF ---
  photoUploading: false,
  photoUploadError: null,
  photoDeleteLoading: false,
  photoDeleteError: null,
  // --- ŞİFRE / DOĞRULAMA KODU ---
  passwordChangeLoading: false,
  passwordChangeError: null,
  passwordChangeSuccess: null,
  sendCodeLoading: false,
  sendCodeError: null,
  sendCodeSuccess: null,
  verifyCodeLoading: false,
  verifyCodeError: null,
  verifyCodeSuccess: null,
  // Oturum / cihaz geçmişi
  sessions: [],
  sessionsLoading: false,
  sessionsError: null,
  sessionsClosing: false,
};

const profileSlice = createSlice({
  name: 'profile',
  initialState,
  reducers: {
    clearProfileErrors: (state) => {
      state.error = null;
      state.updateError = null;
      state.updateSuccess = null;
      state.photoUploadError = null;
      state.photoDeleteError = null;
      state.sendCodeError = null;
      state.sendCodeSuccess = null;
      state.passwordChangeError = null;
      state.passwordChangeSuccess = null;
      state.verifyCodeError = null;
      state.verifyCodeSuccess = null;
      state.usernameEditError = null;
      state.usernameEditSuccess = null;
      state.emailEditError = null;
      state.emailEditSuccess = null;
    },
    resetProfileState: () => initialState,
  },
  extraReducers: (builder) => {
    // PROFİL GETİR
    builder
      .addCase(fetchMyProfile.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchMyProfile.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action.payload;
        
      })
      .addCase(fetchMyProfile.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });

    // PROFİL GÜNCELLE
    builder
      .addCase(updateMyProfile.pending, (state) => {
        state.updateLoading = true;
        state.updateError = null;
        state.updateSuccess = null;
      })
      .addCase(updateMyProfile.fulfilled, (state, action) => {
        state.updateLoading = false;
        state.user = action.payload;
        state.updateSuccess = 'Profil başarıyla güncellendi.';
      })
      .addCase(updateMyProfile.rejected, (state, action) => {
        state.updateLoading = false;
        state.updateError = action.payload;
      });

    // PROFİL FOTOĞRAF YÜKLE/SİL
    builder
      .addCase(uploadProfilePhoto.pending, (state) => {
        state.photoUploading = true;
        state.photoUploadError = null;
      })
      .addCase(uploadProfilePhoto.fulfilled, (state, action) => {
        state.photoUploading = false;
        state.user = action.payload;
        state.photoUploadError = null;
      })
      .addCase(uploadProfilePhoto.rejected, (state, action) => {
        state.photoUploading = false;
        state.photoUploadError = action.payload;
      })
      .addCase(deleteProfilePhoto.pending, (state) => {
        state.photoDeleteLoading = true;
        state.photoDeleteError = null;
      })
      .addCase(deleteProfilePhoto.fulfilled, (state, action) => {
        state.photoDeleteLoading = false;
        state.user = action.payload;
        state.photoDeleteError = null;
      })
      .addCase(deleteProfilePhoto.rejected, (state, action) => {
        state.photoDeleteLoading = false;
        state.photoDeleteError = action.payload;
      });

    // DOĞRULAMA KODU GÖNDER
    builder
      .addCase(sendVerificationCode.pending, (state) => {
        state.sendCodeLoading = true;
        state.sendCodeError = null;
        state.sendCodeSuccess = null;
      })
      .addCase(sendVerificationCode.fulfilled, (state, action) => {
        state.sendCodeLoading = false;
        state.sendCodeSuccess = 'Doğrulama kodu gönderildi.';
      })
      .addCase(sendVerificationCode.rejected, (state, action) => {
        state.sendCodeLoading = false;
        state.sendCodeError = action.payload;
      });

    // DOĞRULAMA KODU DOĞRULA
    builder
      .addCase(verifyCode.pending, (state) => {
        state.verifyCodeLoading = true;
        state.verifyCodeError = null;
        state.verifyCodeSuccess = null;
      })
      .addCase(verifyCode.fulfilled, (state, action) => {
        state.verifyCodeLoading = false;
        state.verifyCodeSuccess = 'Kod doğrulandı.';
      })
      .addCase(verifyCode.rejected, (state, action) => {
        state.verifyCodeLoading = false;
        state.verifyCodeError = action.payload;
      });

    // ŞİFRE DEĞİŞTİR
    builder
      .addCase(changePassword.pending, (state) => {
        state.passwordChangeLoading = true;
        state.passwordChangeError = null;
        state.passwordChangeSuccess = null;
      })
      .addCase(changePassword.fulfilled, (state, action) => {
        state.passwordChangeLoading = false;
        state.passwordChangeSuccess = 'Şifre başarıyla değiştirildi.';
      })
      .addCase(changePassword.rejected, (state, action) => {
        state.passwordChangeLoading = false;
        state.passwordChangeError = action.payload;
      });

    // OTURUM / CİHAZ GEÇMİŞİ
    builder
      .addCase(fetchMySessions.pending, (state) => {
        state.sessionsLoading = true;
        state.sessionsError = null;
      })
      .addCase(fetchMySessions.fulfilled, (state, action) => {
        state.sessionsLoading = false;
        state.sessions = Array.isArray(action.payload) ? action.payload : [];
      })
      .addCase(fetchMySessions.rejected, (state, action) => {
        state.sessionsLoading = false;
        state.sessionsError = action.payload;
      });

    // DİĞER OTURUMLARI KAPAT
    builder
      .addCase(closeOtherSessions.pending, (state) => {
        state.sessionsClosing = true;
        state.sessionsError = null;
      })
      .addCase(closeOtherSessions.fulfilled, (state) => {
        state.sessionsClosing = false;
      })
      .addCase(closeOtherSessions.rejected, (state, action) => {
        state.sessionsClosing = false;
        state.sessionsError = action.payload;
      });
  },
});

export const { clearProfileErrors, resetProfileState } = profileSlice.actions;
export default profileSlice.reducer;
